import { Loading } from 'components/elements'
import { useSession } from 'context/Session'
import * as R from 'ramda'
import { useState } from 'react'
import { useQuery } from 'react-query'

import * as Q from './Questions.styles'
import { loadQuestions, publishQuestion } from '../modules/datasource'

const defaultProps = {}
const propTypes = {}

export const Questions = ({
  questionId,
  initialState,
  data,
  accessToken,
  isMyAMQ,
  isCompleted,
  isStaff,
}) => {
  const [anyFetching, setAnyFetching] = useState(false)
  const [crrPage, setCrrPage] = useState(1)
  const { user } = useSession()
  const [crrListState, setListState] = useState(initialState || {})
  const [answersCount, setAnswersCount] = useState(data?.answers)
  const [commentCount, setCommentCount] = useState(data?.comments)

  const { isFetching, isLoading } = useQuery(
    ['amq-questions', { accessToken, crrPage, questionId }],
    () =>
      crrPage !== 1
        ? loadQuestions({ questionId, page: crrPage, accessToken })
        : initialState || { list: [], total: 0 },
    {
      fetchPolicy: 'no-cache',
      onSuccess: data =>
        setListState(({ list = [] }) => ({
          ...data,
          list: R.uniq(R.concat(list, data?.list)),
        })),
    }
  )

  const config = {
    questionId,
    anyFetching,
    setAnyFetching,
    setListState,
    isMyAMQ,
    isStaff,
    isCompleted,
    data,
    accessToken,
    setAnswersCount,
    setCommentCount,
  }

  const { list = [], total } = crrListState

  if (isLoading && R.isEmpty(list)) {
    return (
      <Q.Container>
        <Loading color="black" style={{ margin: '0 auto' }} />
      </Q.Container>
    )
  }

  const answerIt = ({ text, createAsStaff }) => {
    setAnyFetching(true)
    return publishQuestion({
      accessToken,
      questionId,
      text,
      createAsStaff,
    }).then(({ data }) => {
      // enqueueSnackbar('Your comment is pending approval', {
      //   variant: 'success',
      // })
      setAnyFetching(false)
      setListState(({ list = [], ...crrState }) => ({
        ...crrState,
        list: R.concat([data], list),
      }))
      setAnswersCount(c => c + 1)
    })
  }

  return (
    <Q.Container>
      {user?.profile?.username && (
        <Q.Header>
          <Q.Title>Answer it</Q.Title>
          <Q.PublishOption
            onPublish={answerIt}
            isQuestion
            {...config}
            asTSN={isStaff}
          />
        </Q.Header>
      )}
      <Q.Sumary>
        {/* <Q.AMQFooterQuestionItem questions={questionsCount} /> */}
        <Q.AMQFooterAnswersItem answers={answersCount} />
        <Q.AMQFooterCommentItem comments={commentCount} />
      </Q.Sumary>
      <Q.QuestionList {...config} {...crrListState} />
      {!isFetching && list?.length < total && (
        <Q.ShowMore onClick={() => setCrrPage(p => p + 1)}>
          Show more
        </Q.ShowMore>
      )}
      {isFetching && <Loading color="black" style={{ margin: '0 auto' }} />}
    </Q.Container>
  )
}

Questions.defaultProps = defaultProps
Questions.propTypes = propTypes

export default Questions
